import React from 'react';
import Modal from '../../../../molecules/Modal';

const FilePreviewModal = ({ isOpen, onClose, documentUrl, fileType }) => {
    if (!isOpen) return null;

    const viewableExtensions = ["pdf", "png", "jpg", "jpeg", "gif", "webp", "txt", "html"];
    const imageExtensions = ["png", "jpg", "jpeg", "gif", "webp"];
    
    const getFileExtension = (filename) => {
        return filename?.split(".").pop()?.toLowerCase() || "";
    };
    
    const canPreviewInIframe = (filename) => {
        const ext = getFileExtension(filename);
        return viewableExtensions.includes(ext);
    };
    
    const isImage = (filename) => {
        const ext = getFileExtension(filename);
        return imageExtensions.includes(ext);
    };

    const isPDF = (filename) => {
        const ext = getFileExtension(filename);
        return ext === "pdf";
    };

    return (
        <Modal title="Previsualización del Documento" onClose={onClose}>
            <div className="w-full h-[80vh] flex justify-center items-center bg-gray-50">
                {!canPreviewInIframe(fileType) ? (
                    <p className="text-center text-2xl text-gray-600 p-4">
                        Este tipo de archivo no se puede previsualizar directamente. 
                        Por favor, descárgalo para verlo.
                    </p>
                ) : isImage(fileType) ? (
                    // Para imágenes, usar <img> directamente
                    <img 
                        src={documentUrl} 
                        alt="Documento" 
                        className="max-w-full max-h-full object-contain"
                    />
                ) : isPDF(fileType) ? (
                    <iframe 
                        src={documentUrl}
                        className="h-full w-full border-0"
                        title="Documento PDF"
                    />
                ) : (
                    <iframe 
                        src={documentUrl} 
                        className="h-full w-full border-0" 
                        title="Documento Previsualizado"
                        sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
                    />
                )}
            </div>
        </Modal>
    );
};

export default FilePreviewModal;